import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P6-E1',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    checkUppercase: true,
    padding: 0,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page6/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page6/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page6/E1/3.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page6/E1/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page6/E1/6.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page6/E1/7.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page6/E1/9.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page6/E1/10.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page6/E1/12.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page6/E1/13.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P6-E2',
    audio: '',
    video: '',
    checkUppercase: true,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page6/E2/Key/answerKey.png',
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page6/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page6/E2/3.jpg', input: true, answer: "His" },
        { url: 'img/FriendsPlus/Page6/E2/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page6/E2/6.jpg', input: true, answer: "She's" },
        { url: 'img/FriendsPlus/Page6/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page6/E2/8.jpg', input: true, answer: "He's" },
        { url: 'img/FriendsPlus/Page6/E2/9.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page6/E2/10.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P6-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page6/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page6/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page6/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page6/E3/4.jpg' },
      ],

    ],
  },




}

export default json;